import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location, LocationCreateReq } from 'src/app/models/user/location.model';
import { LocationService } from 'src/app/services/user/location/location.service';
import { SignUp, UserModel } from 'src/app/models/user/user.model';
import { UserService } from 'src/app/services/user/user/user.service';
import { Roles, UserModels } from 'src/app/models/user/role-model';
import { HelperService } from '../../services/helper/helper.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login/login.service';
import { Company } from 'src/app/models/user/company.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  rucToCheck: string = '';
  showComNameField: boolean = false;
  listUserRole: Roles[] = [];
  loading: boolean = false;
  emailPattern: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  companyID: string = '';
  listState: any = [];
  userLogued: string = '';
  existingCompanyId: string = '';
  newCompanyId: string = '';
  locacionCreada:string = ''

  location: Location[] = [];
  myForm: FormGroup = this.fb.group({
    useName: ['', [Validators.required]],
    useLastName: ['', [Validators.required]],
    useEmail: [
      '',
      [Validators.required, Validators.pattern(this.emailPattern)],
    ],
    location: [''],
    comDocument: ['', [Validators.required]],
    password: ['', [Validators.required]],
    comName: [''],
  });

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private locationService: LocationService,
    private helperService: HelperService
  ) {
    this.listUserRole = new UserModels().roles;
    this.listState = new UserModel().listStates;
  }

  ngOnInit(): void {
  }

  registerLocation(): void {
    const locationModel: LocationCreateReq = {
      idCompany: this.newCompanyId,
      locName: 'Local Principal',
      locDepartment: 'Lima',
      locProvince: 'Lima',
      locDistrict: 'Lima',
      locAddress: 'Avenida',
      locNote: 'Nota no asignada',
      locPhone: '999999999',
      locReference: 'Referencia no asignada',
      locWebSite: 'locacion.pe',
      locUserCreation: this.myForm.value.useName,
    };

    // Agregar un console.log para imprimir los datos antes de enviarlos al servidor
    console.log('Datos de la locación que se enviarán al servidor:', locationModel);

    this.locationService.createLocation(locationModel).pipe(
      catchError((error) => {
        console.error('Hubo un error al crear la locación', error);
        this.toastr.error('Hubo un error al crear la locación', 'Error');
        throw error;
      })
    ).subscribe((response) => {
      // Puedes agregar lógica adicional aquí si es necesario.
      console.log('Respuesta del servidor al crear la locación:', response);
      this.locacionCreada = response.idLocation
      console.log('Luis está casado');
      this.registerUser();
    });
  }

  registerUser() {
      const userModel: SignUp = {
        idCompany: this.newCompanyId,
        idLocation: this.locacionCreada,
        password: this.myForm.value.password,
        useName: this.myForm.value.useName,
        useLastName: this.myForm.value.useLastName,
        useEmail: this.myForm.value.useEmail,
        roles: ['admin'],
      };
      this.loading = true;

      this.userService
        .registerUser(userModel)
        .pipe(
          catchError((error) => {
            console.error('Ususario ya existe, intentelo otra vez.', error);
            this.toastr.error(
              'Ususario ya existe, intentelo otra vez.',
              'Error'
            );
            throw error; // Re-throw the error to continue propagating it
          })
        )
        .subscribe((res) => {
          this.loading = false;
          console.log('Usuario registrado exitosamente:', res);
          this.toastr.success('Usuario registrado exitosamente.', 'Éxito');
          this.router.navigate(['/login']);
        });

  }
  verifyDocument() {
    this.loginService.getRucCompany(this.rucToCheck).subscribe(
      (response) => {
        console.log('Respuesta del servidor:', response);
        console.log('funciona');
        this.existingCompanyId = response.idCompany

        // this.loginUser();
        this.loginService.setCompany(response);

      },
      (error) => {
        error.status === 404;
        this.toastr.error('RUC no encontrado', 'iNCORRECTO');
        this.showComNameField = true;
        console.log('RUC no existe');
      }
    );
  }
  createCompany(): void {
    if (this.showComNameField === true) {
      const companyModel: Company = {
        idCompany: '',
        comDocument: this.myForm.value.comDocument,
        comName: this.myForm.value.comName,
        comSearch: '',
        comState: 'Enabled',
        comUserCreation: this.myForm.value.useName,
        comDateCreation: new Date(),
        comUserModification: '',
        comDateModification: new Date(),
      };

      // Agregar un console.log para imprimir los datos antes de enviarlos al servidor
      console.log('Datos de la compañía que se enviarán al servidor:', companyModel);

      this.loginService.createCompany(companyModel).pipe(
        catchError((error) => {
          console.error('No se pudo crear la compañía', error);
          this.toastr.error('No se pudo crear la compañia, inténtelo otra vez.', 'Error');
          throw error; // Re-throw the error to continue propagating it
        })
      ).subscribe((response) => {
        console.log('ID de la compañía creada:', response.idCompany);
        console.log('Empresa creada exitosamente:', response);
        this.loginService.setCompany(response);
        this.newCompanyId = response.idCompany
        this.registerLocation();
      });
    } else {
      // Puedes agregar una lógica adicional aquí si es necesario.
    }
  }

}
